/* eslint-disable react/prop-types */
import React, { createContext } from 'react';
import proptypes from 'prop-types';
const { node } = proptypes;

import { useClearCallbackVerification } from '../hooks/useClearCallbackVerification'

export const defaultContext = {
  data: {},
  loading: true,
  error: '',
  executeRequest: async () => {},
};

export const ClearCallbackVerificationApiContext = createContext(defaultContext);

const ClearCallbackVerificationApiProvider = ({
  code,
  state,
  error,
  errorDescription,
  children
}) => {

  return (
    <ClearCallbackVerificationApiContext.Provider
      value={
        { ...useClearCallbackVerification({ code, state, error, errorDescription }) }
      }
    >
      {children}
    </ClearCallbackVerificationApiContext.Provider>
  );
};

ClearCallbackVerificationApiProvider.propTypes = {
  children: node.isRequired
};

export default ClearCallbackVerificationApiProvider;
